"use client";

import { c as _c } from "react/compiler-runtime";
import { ConfigurationCard } from "@/components/configuration/card";
import { Carousel, CarouselApi, CarouselContent, CarouselItem } from "@/components/rac/carousel";
import { ArrowRight } from "lucide-react";
import { useState } from "react";
export interface Configuration {
  id: string;
  type: string; // bhktype - studio/2bhk etc
  price: string;
  bedrooms: number;
  bathrooms: number;
  facing: string;
  builtupArea?: string;
  image: string;
  plotArea?: string;
  basePrice?: string;
  projectName: string;
  locality: string;
  projectId: string;
}
interface ProjectConfigurationsProps {
  configurations: Configuration[];
}
export function ProjectConfigurations(t0) {
  const $ = _c(38);
  const {
    configurations
  } = t0;
  const [api, setApi] = useState();
  const [selectedType, setSelectedType] = useState("");
  if (!configurations || configurations.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== configurations) {
    t1 = Object.keys(Object.fromEntries(Object.entries(configurations.reduce(_temp, {})).filter(_temp2)));
    $[0] = configurations;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const configTypes = t1;
  if (!selectedType && configTypes.length > 0) {
    setSelectedType(configTypes[0]);
  }
  let T0;
  let T1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] !== api || $[3] !== configTypes || $[4] !== configurations || $[5] !== selectedType) {
    let t8;
    if ($[14] !== selectedType) {
      t8 = config_0 => config_0.type === selectedType;
      $[14] = selectedType;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    const filteredConfigs = configurations.filter(t8);
    t7 = "pb-6";
    T1 = Carousel;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        align: "center",
        loop: true
      };
      $[16] = t3;
    } else {
      t3 = $[16];
    }
    t4 = "w-full";
    t5 = setApi;
    let t9;
    if ($[17] !== configTypes || $[18] !== selectedType) {
      t9 = <div className="flex gap-2 mb-2 lg:mb-8 overflow-x-auto">{configTypes.map(type => <button type="button" key={type} onClick={() => {
          setSelectedType(type);
        }} className={`cursor-pointer py-2 px-4 text-sm font-bold font-ruda border-b-2 transition-colors whitespace-nowrap
							${selectedType === type ? "border-red-500 text-red-500 bg-white" : "border-transparent text-gray-600 bg-gray-50"}
						`} style={{
          minWidth: 100
        }}>{type}</button>)}</div>;
      $[17] = configTypes;
      $[18] = selectedType;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    let t10;
    if ($[20] !== api) {
      t10 = api?.canScrollNext() && <div className="flex gap-2 justify-end mb-2 self-end lg:self-auto lg:justify-end"><button type="button" onClick={() => api?.scrollPrev()} disabled={!api?.canScrollPrev()} className="cursor-pointer static text-black border-gray-300 h-10 w-20 rounded-md flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed bg-gray-100 hover:bg-gray-200 border" aria-label="Previous project"><ArrowRight className="w-4 h-4 rotate-180" /></button><button type="button" onClick={() => api?.scrollNext()} disabled={!api?.canScrollNext()} className="cursor-pointer static text-black border-gray-300 h-10 w-20 rounded-md flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed bg-gray-100 hover:bg-gray-200 border" aria-label="Next project"><ArrowRight className="w-4 h-4" /></button></div>;
      $[20] = api;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    if ($[22] !== t10 || $[23] !== t9) {
      t6 = <div className="lg:flex lg:justify-between">{t9}{t10}</div>;
      $[22] = t10;
      $[23] = t9;
      $[24] = t6;
    } else {
      t6 = $[24];
    }
    T0 = CarouselContent;
    t2 = filteredConfigs.map(_temp3);
    $[2] = api;
    $[3] = configTypes;
    $[4] = configurations;
    $[5] = selectedType;
    $[6] = T0;
    $[7] = T1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    T0 = $[6];
    T1 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
  }
  let t8;
  if ($[25] !== T0 || $[26] !== t2) {
    t8 = <T0>{t2}</T0>;
    $[25] = T0;
    $[26] = t2;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== T1 || $[29] !== t3 || $[30] !== t4 || $[31] !== t5 || $[32] !== t6 || $[33] !== t8) {
    t9 = <T1 opts={t3} className={t4} setApi={t5}>{t6}{t8}</T1>;
    $[28] = T1;
    $[29] = t3;
    $[30] = t4;
    $[31] = t5;
    $[32] = t6;
    $[33] = t8;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[35] !== t7 || $[36] !== t9) {
    t10 = <><div className={t7}>{t9}</div></>;
    $[35] = t7;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  return t10;
}
function _temp3(config_1) {
  return <CarouselItem key={config_1.id} className="flex justify-center md:flex-[0_0_50%]! lg:flex-[0_0_33%]!"><div className="w-full m-2 transition-all duration-300 hover:shadow-xl hover:scale-[1.02] rounded-2xl overflow-hidden"><ConfigurationCard config={config_1} isActive={true} /></div></CarouselItem>;
}
function _temp2(t0) {
  const [, value] = t0;
  return value;
}
function _temp(acc, config) {
  acc[config.type] = true;
  return acc;
}